module.exports = __webpack_public_path__ + "img/商汤.0a360079.jpg";